import { render } from "./DashboardBi.vue?vue&type=template&id=298ee3fb"
import script from "./DashboardBi.vue?vue&type=script&lang=js"
export * from "./DashboardBi.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__